<div class="container-fluid">

  <div class="ff-container-title-height">
    @if (isInTab() === false) {
      <h1 class="text-center">FastFetch</h1>
    }
    @else {
      <h4 class="text-center">FastFetch</h4>
    }
  </div>

  <div>
    <h6 class="title-center my-2" style="color: red;">FastFetch does not support CSV Data Source Type or Self Hosted Clients</h6>
  </div>

  <div class="ff-container-main-height">

    @if (hasDestinations() && !isInTab() && filteredDestinations().length > 1) {
      <div class="dest-switch text-center">
        <app-lt-button-toggle 
            [options]="destinationOptions()"
            [value]="selectedDestinationValue()"
            (valueChange)="onDestinationChange($event)"
            [multiple]="false"
            [hideSingleSelectionIndicator]="true">
        </app-lt-button-toggle>
      </div>
    }

    @if(gridSettings() && settingsReady() && (selectedDestination() || isInTab())) {
      <app-lt-png-table
        [showToolbarInput]="false"
        [gridSettingsInput]="gridSettings()"
        (selectionChange)="handlePgGridSelection($event)">
      </app-lt-png-table>
    }

    @if (selectedDestination() || isInTab()) {
      <div >

        @if (selectedIntegration()) {
          <div class="ff-main-form-area">
            
            <div class="ff-client-header-container d-flex align-items-center gap-3">
              @if (isInTab() === false) {
                <h2>Client: {{selectedIntegration().clientName}}</h2>
                <button title="Change Client Button" class="btn ff-edit-button" 
                  (click)="changeClient()" 
                  matTooltip="Change Client"
                  matTooltipPosition="right">
                  <i class="bi bi-pencil"></i>
                </button>
              } @else {
                <h5>Client: {{selectedIntegration().clientName}}</h5>
              }
            </div>

            @if (isInTab() === true && selectedIntegration()) {
              <div>
                <h5>Integration: {{selectedIntegration().identifierNameValue}}</h5>
              </div>
            }

            <div class="ff-email-container d-flex align-items-center">
              <h5 class="ff-email-padding-right">Currently sending to: {{getSNEmail(activeUser.userName)}}</h5>
              <mat-checkbox [checked]="overrideEmail()" (change)="changeOverrideEmailCheck()">
                Override Email Address
              </mat-checkbox>
              <mat-checkbox [(ngModel)]="useLambdaProcessing">
                  Process in Lambdas
              </mat-checkbox>
            </div>

            @if (overrideEmail()) {
              <mat-form-field appearance="fill" class="ff-dropdown-has-client">
                <mat-label>Email to send FastFetch update to:</mat-label>
                <input type="email" matInput [formControl]="emailFormControl" placeholder="Ex. test@example.com">
                @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
                  <mat-error>
                    Please enter a valid email address
                  </mat-error>
                }
                @if (emailFormControl.hasError('required')) {
                  <mat-error>
                    Email is <strong>required</strong>
                  </mat-error>
                }
              </mat-form-field>
            }

            <div class="ff-loan-table-view card">
              <div class="card-body">
                <app-loan-number-table (loansChange)="onLoansChange($event)"></app-loan-number-table>
              </div>
            </div>

            <div class="submit-fastfetch-buttons d-flex align-items-center justify-content-start">
              <button type="button" class="btn btn-outline-dark" (click)="clearFastFetchFormData()">
                Clear Form
              </button>
              <button type="button" class="btn btn-outline-dark" (click)="submitFastFetchRequest()" [disabled]="ffLoansSignal().length > 300 || ffLoansSignal().length < 1">Submit</button>
              @if (ffLoansSignal().length > 0) {
                <button type="button" class="btn btn-outline-dark"
                (click)="clearFastFetchLoanGrid()">Clear Loan Grid</button>
              }
              <span class="mx-2 ff-loan-count-text ms-auto pe-1 text-danger">Max Loan Count Per Request: 300 loans. Current Count: {{ffLoansSignal().length}}</span>
            </div>
          </div>
        }
      </div>
    }

    <app-lt-page-loading-message
      [loading]="pageLoading()"
      [loadingFailed]="!pageLoading() && !allDestinations()">
    </app-lt-page-loading-message>

  </div>

</div>

<ng-template #loanProgressDialog>
  <h2 matDialogTitle>Request Sending...</h2>
  <mat-dialog-content>
    @if (loansBeingProcessed()) {
      <section class="progress-bar-section d-flex align-content-center align-items-center flex-column">
        <mat-progress-bar class="progress-bar-margin" [color]="'primary'" [mode]="'buffer'" [value]="progressBarValue()"
          [bufferValue]="progressBarBufferValue()">
        </mat-progress-bar>
        <mat-label>Loans being sent to FastFetch Queue</mat-label>
      </section>
    } @else {
      <h6>{{loansProcessedResponse()}}</h6>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton matDialogClose color="primary">Close</button>
  </mat-dialog-actions>
</ng-template>
